<script>
export default {
    props: ['data'],
    name: "galleryBanner",
    data() {
        return {
            swiperOptions1: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: '.swiper-pagination',
                },
            },
            swiperOptions2: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                pagination: {
                    el: '.swiper-pagination',
                },
            },
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {},
};
</script>

<template>
    <swiper class="gallery_banner" ref="mySwiper" :options="data.length > 1 ? swiperOptions1 : swiperOptions2">
        <swiper-slide v-for="(item, index) in data" :key="index">
            <div class="layout_bg bg" :style="`background-image: url(${item.image});`"></div>
            <div class="layout_main flex justify_between align_end content">
                <div class="text">
                    <div class="title" v-html="$textToHtml(item.title)"></div>
                    <div class="desc" v-html="$textToHtml(item.desc)"></div>
                </div>
                <a class="btn layout_flex_center" v-if="item.link" :href="item.link">了解更多</a>
            </div>
        </swiper-slide>
        <div class="swiper-pagination flex justify_center" slot="pagination"></div>
    </swiper>
</template>

<style scoped lang="scss">
.gallery_banner{
    height: 4.8rem;
    @media only screen and (max-width: 750px) {
        height: 6.3rem;
    }
    .bg{
        position: absolute;
    }
    .content{
        position: relative;
        height: 100%;
        padding-bottom: .6rem;
        color: #fff;
        .text{
            // width: 3.75rem;
        }
        .title{
            font-size: .25rem;
        }
        .desc{
            // width: 3.8rem;
            padding-bottom: .6rem;
            font-size: .25rem;
        }
        .btn{
            width: 1.2rem;
            height: .4rem;
            border-radius: .05rem;
            border: 1px solid #fff;
            font-size: .18rem;
            line-height: 1;
            flex-shrink: 0;
        }
        @media only screen and (max-width: 750px) {
            text-align: center;
            .title{
                font-size: .36rem;
                margin-bottom: .5rem;
            }
            .desc{
                font-size: .28rem;
            }
            .btn{
                display: none;
            }
        }
    }
    .swiper-pagination{
        width: 100%;
        bottom: .4rem;
        gap: .06rem;
        /deep/ .swiper-pagination-bullet{
            width: .12rem;
            height: .12rem;
            opacity: 1;
            border: 1px solid #fff;
            &-active{
                background: #fff;
            }
        }
    }
}
</style>